import React, { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import colors from "../../theme/Theme";

const NavOptions = ({ activeItem, onItemClick, isMobile = false }) => {
  const location = useLocation();
  const [openMenu, setOpenMenu] = useState(null);
  const menuRef = useRef(null);
  const closeTimeoutRef = useRef(null);

  const options = ["Inicio", "Comprar", "Productos", "Nosotros", "Preguntas frecuentes", "Contacto"];

  const buyOptions = [
    { name: "Mayorista", path: "/mayorista" },
    { name: "Por metro", path: "/productos/FibraDeCarbono" },
    { name: "Por medida", path: "/ecommerce" },
  ];

  const productOptions = [
    { name: "Fibra de carbono", path: "/productos/FibraDeCarbono" },
    { name: "Resinas y catalizadores", path: "/productos/ResinaCatalizador" },
    { name: "Flakes", path: "/productos/Flakes" },
  ];

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setOpenMenu(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      if (closeTimeoutRef.current) {
        window.clearTimeout(closeTimeoutRef.current);
      }
    };
  }, []);

  const clearCloseTimeout = () => {
    if (!closeTimeoutRef.current) return;
    window.clearTimeout(closeTimeoutRef.current);
    closeTimeoutRef.current = null;
  };

  const openDesktopMenu = (option) => {
    clearCloseTimeout();
    setOpenMenu(option);
  };

  const closeDesktopMenu = () => {
    clearCloseTimeout();
    closeTimeoutRef.current = window.setTimeout(() => {
      setOpenMenu(null);
      closeTimeoutRef.current = null;
    }, 180);
  };

  const isOptionActive = (option) => {
    if (option === "Comprar") {
      return location.pathname.startsWith("/mayorista") || location.pathname.startsWith("/ecommerce");
    }
    if (option === "Productos") {
      return location.pathname.startsWith("/productos");
    }
    return activeItem === option;
  };

  const handleOptionClick = (option) => {
    if (option === "Comprar" || option === "Productos") {
      setOpenMenu((current) => (current === option ? null : option));
      return;
    }

    onItemClick(option);
    setOpenMenu(null);
  };

  const handleSubOptionClick = (parent, path) => {
    onItemClick(parent, path);
    setOpenMenu(null);
  };

  const renderMenuItems = (parentOption) => {
    const items = parentOption === "Comprar" ? buyOptions : productOptions;

    return (
      <div
        className={`absolute left-0 top-full z-50 rounded-md bg-black shadow-lg ${
          isMobile ? "w-full" : "min-w-[235px]"
        }`}
        onMouseEnter={!isMobile ? clearCloseTimeout : undefined}
        onMouseLeave={!isMobile ? closeDesktopMenu : undefined}
      >
        {items.map((item) => (
          <button
            key={item.path}
            type="button"
            onClick={() => handleSubOptionClick(parentOption, item.path)}
            className="block w-full px-4 py-3 text-left text-white transition-colors hover:bg-primary-green"
          >
            {item.name}
          </button>
        ))}
      </div>
    );
  };

  return (
    <div className={`nav-options-container ${isMobile ? "mobile" : "desktop"}`} ref={menuRef}>
      {options.map((option) => {
        const isActive = isOptionActive(option);
        const hasMenu = option === "Comprar" || option === "Productos";
        const isOpen = openMenu === option;

        return (
          <div
            key={option}
            className="relative"
            onMouseEnter={!isMobile && hasMenu ? () => openDesktopMenu(option) : undefined}
            onMouseLeave={!isMobile && hasMenu ? closeDesktopMenu : undefined}
          >
            <div
              onClick={() => handleOptionClick(option)}
              className="nav-option"
              style={{
                borderBottom: isActive ? `3px solid ${colors.greenPrimary}` : "none",
                "--text-color": isActive ? colors.greenPrimary : colors.white,
                "--hover-color": colors.greenPrimary,
                fontWeight: 700,
                fontSize: isMobile ? "1.15rem" : "1.2rem",
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                gap: "4px",
              }}
            >
              {option}
              {hasMenu && (
                <svg
                  className={`transition-transform ${isOpen ? "rotate-180" : ""}`}
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M6 9L12 15L18 9"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              )}
            </div>

            {hasMenu && isOpen && renderMenuItems(option)}
          </div>
        );
      })}
    </div>
  );
};

export default NavOptions;
